var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-120 bg-fdfdff flex items-center justify-center text-white"},[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":require("../../assets/logo.png")}})])
}]

export { render, staticRenderFns }